import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LoadingProvider } from "./context/LoadingContext";
import CatMascot from "./components/CatMascot";
import Login from "./pages/Login";
import Callback from "./pages/Callback";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import Staff from "./pages/Staff";
import Customers from "./pages/Customers";
import Settings from "./pages/Settings";
import MemberPortal from "./pages/MemberPortal";
import { motion } from "framer-motion";

const BootScreen = () => (
  <div className="flex h-screen w-screen flex-col items-center justify-center bg-[#0A0C10]">
    <motion.div animate={{ scale: [1, 1.1, 1] }} transition={{ repeat: Infinity, duration: 1.2 }}>
      <CatMascot size={80} />
    </motion.div>
    <p className="mt-4 font-display text-xs uppercase tracking-[0.3em] text-purple-400">Loading Kingdom</p>
  </div>
);

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <BootScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.user_type !== "staff") return <MemberPortal />;
  return <Layout>{children}</Layout>;
};

function AppRoutes() {
  const { user, loading } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={loading ? <BootScreen /> : user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/auth/callback" element={<Callback />} />
      <Route path="/" element={new URLSearchParams(window.location.search).get("code") ? <Callback /> : <Protected><Dashboard /></Protected>} />
      <Route path="/events" element={<Protected><Events /></Protected>} />
      <Route path="/events/:id" element={<Protected><EventDetail /></Protected>} />
      <Route path="/staff" element={<Protected><Staff /></Protected>} />
      <Route path="/customers" element={<Protected><Customers /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LoadingProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
        </LoadingProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
